import { render, staticRenderFns } from "./IconFormat.vue?vue&type=template&id=45eed2e5&"
import script from "./IconFormat.vue?vue&type=script&lang=ts&"
export * from "./IconFormat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports